import { Resolver } from '@wellyes/react-router-extended';
import { HttpService } from '@core/services';
import { PermittingHttpService } from '@core/services/http';
import { BROWSE_DEFAULT_FILTER_VALUE } from '@models/constants';
import { OptionProps, PermittingBrowseFilter } from '@models/interfaces';
import { PermittingActions } from '@store/actions';
import store from '@store/index';

export class PermittingBrowseResolver implements Resolver {
  private get _permittingUsersOptions(): OptionProps[] {
    return store.getState().permitting.permittingUsersOptions;
  }

  async resolve(): Promise<void> {
    store.dispatch(PermittingActions.resetTabsData.done());

    const promises: Promise<unknown>[] = [
      HttpService.getHttpRequests(
        PermittingHttpService,
      ).getPermittingBrowseData(
        BROWSE_DEFAULT_FILTER_VALUE as PermittingBrowseFilter,
      ),
    ];

    if (!this._permittingUsersOptions.length) {
      promises.push(
        HttpService.getHttpRequests(
          PermittingHttpService,
        ).getPermittingUsersOptions(),
      );
    }

    await Promise.all(promises);
  }
}
